import { gql } from 'graphql-request';

import { BillID, BillUUID } from '../billsTypes';

export interface CancelBillQueryResponse {
  id: BillID;
  uuid: BillUUID;
}

export const CANCEL_BILL_QUERY = gql`
  mutation CancelBill($uuid: ID!) {
    cancelBill(input: { uuid: $uuid }) {
      recordUuid
      status
      record {
        id
        uuid
      }
      errors {
        fullMessages
      }
    }
  }
`;
